import { ReactNode, useId } from "react"

import { Box, Stack, SxProps, Theme, Typography } from "@mui/material"

const DashboardKpiCard = ({
  accent,
  icon,
  iconBgColor = "mockup.neutral95",
  iconColor = "mockup.neutral10",
  iconGap = "auto",
  value,
  valueColor = "mockup.neutral10",
  label,
  trend,
  footer,
  children,
  sx,
}: {
  accent: string
  icon?: ReactNode
  iconBgColor?: string
  iconColor?: string
  iconGap?: number | "auto"
  value: string
  valueColor?: string
  label: string
  trend?: ReactNode
  footer?: ReactNode
  children?: ReactNode
  sx?: SxProps<Theme>
}) => {
  const labelId = useId()

  return (
    <Stack
      role="group"
      aria-labelledby={labelId}
      sx={[
        {
          bgcolor: "mockup.neutral100",
          border: "1px solid",
          borderColor: "mockup.neutral90",
          borderTop: "4px solid",
          borderTopColor: accent,
          borderRadius: "16px",
          p: 2,
          rowGap: 0.5,
          justifyContent: "flex-end",
          height: "100%",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {icon && (
        <Box
          aria-hidden
          sx={{
            width: 32,
            height: 32,
            borderRadius: "8px",
            bgcolor: iconBgColor,
            color: iconColor,
            display: "grid",
            placeItems: "center",
            mb: iconGap,
          }}
        >
          {icon}
        </Box>
      )}
      {children}
      {trend}
      <Typography
        variant="h2"
        component="p"
        color={valueColor}
        fontWeight={700}
      >
        {value}
      </Typography>
      <Typography
        variant="body2"
        color="mockup.neutral30"
        fontWeight={500}
        id={labelId}
      >
        {label}
      </Typography>
      {footer}
    </Stack>
  )
}

export default DashboardKpiCard
